<template>
  <div>
    <div data-qa-id="blur-earning-report" class="earning-report earning-report--blur">
      <div class="earning-report-header-div">
        <div data-qa-id="earning-report-chart-type" class="earning-report__chart-type fou-tab">
          <button
            data-qa-id="chart-filter-type-earnings"
            :class="['fou-tab__item', {'fou-tab__item--active':isEarningReport}]"
            @click="changeEarningType('earnings')"
          >
            {{ $t('pages.dashboard.earnings') }}
          </button>
          <button
            data-qa-id="chart-filter-type-oders"
            :class="['fou-tab__item', {'fou-tab__item--active':!isEarningReport}]"
            @click="changeEarningType('orders')"
          >
            {{ $t('pages.dashboard.orders') }}
          </button>
        </div>
        <div class="blur-date-picker">
          <date-select-dropdown data-qa-id="btn-selected-label-mobile"
          :isBlur="true" :options="DATE_RANGE_OPTIONS" />
        </div>
      </div>
      <div class="chart-wrap">
        <!-- graph start -->
        <div class="no-chart-data">
          <img class="empty-graph" :src="graphSvg" alt="blur graph" />
        </div>
        <!-- graph end -->
        <!-- report meta data start -->
        <div class="chart-data" data-qa-id="line-chart-data">
          <div class="chart-data__total-earnings">
            <div class="chart-data__total-earnings__title">
              {{ $t(`pages.dashboard.components.report.${totalLabel}`) }}
            </div>
            <div data-qa-id="earning-total" class="chart-data__total-earnings__value">
              <span class="is-blur--more"> 
                {{ totalValue }}
              </span>
            </div>
          </div>
          <div class="chart-grid">
            <div data-qa-id="highest-sales-on">
              <div data-qa-id="highest-sales-on-title" class="chart-grid__title">
                {{ $t(`pages.dashboard.components.report.${highest}`) }}
              </div>
              <div v-if="isEarningReport">
                <div data-qa-id="highest-sales-on-date" class="chart-grid__text is-blur is-blur--less">
                  {{ blurReport.earning.date }}
                </div>
                <div data-qa-id="highest-sales-on-amount" class="chart-grid__text is-blur is-blur--less">
                  {{ blurReport.earning.highest_sales }}
                </div>
              </div>
              <div v-else data-qa-id="top-license-amount" class="chart-grid__text is-blur is-blur--less">
                {{ blurReport.order.count }}
              </div>
            </div>
            <div data-qa-id="top-family">
              <div data-qa-id="top-family-label" class="chart-grid__title">
                {{ $t(`pages.dashboard.components.report.${topCount}`) }}
              </div>
              <div v-if="isEarningReport">
                <div data-qa-id="top-family-name" class="chart-grid__text is-blur is-blur--less">
                  {{ blurReport.earning.family }}
                </div>
                <div data-qa-id="top-family-amount" class="chart-grid__text is-blur is-blur--less">
                  {{ blurReport.earning.family_amount }}
                </div>
              </div>
              <div v-else data-qa-id="top-license-amount" class="chart-grid__text is-blur is-blur--less">
                {{ blurReport.order.platform }}
              </div>
            </div>
            <div data-qa-id="top-license-type">
              <div data-qa-id="" class="chart-grid__title">
                {{ $t(`pages.dashboard.components.report.${topLicenseCountry}`) }}
              </div>
              <div v-if="isEarningReport">
                <div data-qa-id="top-license-platform" class="chart-grid__text is-blur is-blur--less">
                  {{ blurReport.earning.license }}
                </div>
                <div data-qa-id="top-license-amount" class="chart-grid__text is-blur is-blur--less">
                  {{ blurReport.earning.license_amount }}
                </div>
              </div>
              <div v-else data-qa-id="top-license-amount" class="chart-grid__text is-blur is-blur--less">
                {{ blurReport.order.country }}
              </div>
            </div>
          </div>
        </div>
        <!-- report meta data end -->
        <!-- view report button start -->
        <div class="chart-actions">
          <button
            data-qa-id="btn-goto-report" 
            :class="['btn', viewReportBtnClass]"
            disabled
          >
            <span class="report-icon" />{{ $t('pages.dashboard.components.report.view_report') }}
          </button>
        </div>
        <!-- view report button end -->
      </div>
    </div>
  </div>
</template>

<script src="./script.js" />
<style lang="scss" src="../../../../pages/dashboard/stylesheets/index.scss" />
